/**
 * @public
 */
export var defaultLocale = [
    {
        text: 'Heading',
        title: "# h1 Heading\n## h2 Heading\n### h3 Heading\n#### h4 Heading\n##### h5 Heading\n###### h6 Heading"
    },
    {
        text: 'Horizontal Rules',
        title: "___\n---\n***"
    },
    {
        text: 'Bold',
        title: "**This is bold text**\n__This is bold text__"
    },
    {
        text: 'Italic',
        title: "*This is italic text*\n_This is italic text_"
    },
    {
        text: 'Strikethrough',
        title: "~~Strikethrough~~"
    },
    {
        text: 'Blockquote',
        title: "> Blockquotes can also be nested\n>> by using additional greater-than signs\n> > > or with spaces between arrows."
    },
    {
        text: 'Unordered List',
        title: "+ Create a list by starting a line\n+ Sub-lists are made by indenting 2 spaces:\n  - Marker character change forces new list start:\n    * Ac tristique libero volutpat at\n    + Facilisis in pretium nisl aliquet\n    - Nulla volutpat aliquam velit\n+ Very easy!"
    },
    {
        text: 'Ordered List',
        title: "1. Lorem ipsum dolor sit amet\n2. Consectetur adipiscing elit\n3. Integer molestie lorem at massa"
    },
    {
        text: 'Inline Code',
        title: 'Inline `code`'
    },
    {
        text: 'Indented Code',
        title: "\n    // Some comments\n    line 1 of code\n    line 2 of code\n    line 3 of code\n"
    },
    {
        text: 'Block Code',
        title: "```js\nvar foo = function (bar) {\n  return bar++;\n};\n\nconsole.log(foo(5));\n```"
    },
    {
        text: 'Table',
        title: "Option | Description\n--- | ---\ndata | path\nengine | engine\next | extension"
    },
    {
        text: 'Link',
        title: "[link text](http://example.com)\n[link with title](http://example.com 'title text!')"
    },
    {
        text: 'Image',
        title: "![bar](https://example.com/foo.png)\n![foo](https://example.com/foo.jpg 'foo')"
    }
];
/**
 * @public
 */
export function getLocale(locale) {
    return locale || defaultLocale;
}
/**
 * @public
 */
export function getTitleClass(element) {
    var position = element.getClientRects()[0].left > element.parentElement.getClientRects()[0].width / 2 ? 'right' : 'left';
    return "markdown-tip-item-title markdown-tip-item-title-" + position;
}
/**
 * @public
 */
export var defaultTitleClass = 'markdown-tip-item-title-left';
